module.exports = __webpack_public_path__ + "img/time_frame@2x.e1a5f8f9.png";